import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Vendor } from '../helpers/InterfacesServer';

interface VendorsState {
  value: Vendor[]
}

export const vendors = createSlice({
  name: 'vendors',
  initialState: {
    value: [],
  } as VendorsState,
  reducers: {
    setVendors: (state, action: PayloadAction<Vendor[]>) => {
      state.value = action.payload
    },
  },
})

export const { setVendors } = vendors.actions;
export default vendors.reducer;